import {connect} from '@viskan/deku-redux';
import {categoryFetch} from '../category/actions';
import {setPerson} from '../customer/actions';
import {getTranslator} from '../sources/translator';
import {update as updateShopcart} from '../shopcart/actions';
import {fetch, getDeliveryPoints, setChosenCity, setChosenDeliveryPoint, setIntegrities} from './actions';
import Checkout from './components';

export default connect(
	state => ({
		checkout: state.checkout,
		contentManagementActive: state.site.cmsTokenSet,
		countryCode: state.site.country_code,
		customer: state.customer,
		getTranslation: getTranslator(state),
		analyticsClientId: state.site.analyticsClientId,
		languageId: state.site.lang_id,
		locale: state.site.locale.toLowerCase(),
		isPending: state.checkout.pendingActions.length > 0,
		router: state.router,
		shopcart: state.shopcart,
		shopcartAvailable: state.checkout.shopcartAvailable,
		specialParameters: state.checkout.specialParameters,
		integrities: state.checkout.integrities
	}), {
		categoryFetch,
		fetch,
		getDeliveryPoints,
		setChosenCity,
		setChosenDeliveryPoint,
		setPerson,
		setIntegrities,
		updateShopcart
	}
)(Checkout);
